import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4lang_ru_RU from '@amcharts/amcharts4/lang/ru_RU';
const COLORS = [
  '#0975da',
  '#828282',
  '#edd10b',
  '#32b212',
  '#71058f'];
class LineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    am4core.options.commercialLicense = true;
    let chart = am4core.create(this.props.id, am4charts.XYChart);
    chart.language.locale = am4lang_ru_RU;
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'category';
    categoryAxis.renderer.grid.template.location = 1;
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    chart.cursor = new am4charts.XYCursor();
    this.chart = chart;
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (JSON.stringify(this.state.data) !== JSON.stringify(data)) {
      this.deleteSeries();
      this.setState({ data }, () => {
        this.chart.data = data;
      });
    }
  }

  deleteSeries = () => {
    const { chart } = this;
    const { series } = this.props;
    while (chart.series.length > 1) {
      chart.series.removeIndex(0).dispose();
    }
    setTimeout(() => {
      series.forEach((element, index) => {
        this.addSeries(element.name, COLORS[index]);
      });
    }, 500);
  };

  addSeries = (name, colorValue) => {
    const series = this.chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = name;
    series.name = name;
    series.dataFields.categoryX = 'category';
    series.tooltipText = '{name}: [bold]{valueY}[/]';
    series.strokeWidth = 3;
    series.fill = am4core.color(colorValue);
    series.stroke = am4core.color(colorValue);
    series.tooltip.background.color = am4core.color(colorValue);
  };

  render() {
    const { height = '40vh' } = this.props;
    return <div id={this.props.id} style={{ height: height }} />;
  }
}

export default LineChart;